import config from "../core/config";

/**
 * Submit a connector request to the backend.
 *
 * @example
 * await submitConnectorRequest({
 *   connector_id: "slack",
 *   connector_name: "Slack",
 *   email: "alex@contoso.com",
 *   source: "onboarding",
 * });
 * // => { message: "Request received for Slack..." }
 */
export async function submitConnectorRequest(payload) {
  const response = await fetch(`${config.BACKEND_URL}/business/connector-requests`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    credentials: "include",
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || "Failed to submit connector request.");
  }

  return data;
}
